import React, { Component } from "react";
import { UncontrolledAlert} from "reactstrap";
import { withFormsy } from "formsy-react";
import { mealPlanService } from "./services/mealPlan.services";
import { AsyncSelect } from "../../Shared/Forms";
import { Spinner } from "../../Shared";
//import { toast } from "react-toastify";
import { MdClose } from "react-icons/md";
import "./async.css";

class AsyncFoodLibraryDropDown extends Component {
    state = {
        fetching: false,
        fetched: false,
        response: null,
        error: null,
        showToast: false,
        foodItem: null,
    };
    cancelToast = () => {
        this.setState({
            showToast: false,
            foodItem: null,
        });
    };
    asyncGetFoodItems = (inputValue, callback) => {
        if (inputValue && inputValue.length > 2) {
            this.setState({ foodItem: inputValue });
            mealPlanService
                .getFoodItems({ "search-key": inputValue })
                .then((response) => {
                    if (response) {
                        this.setState({ response, error: null, fetching: false });
                        if (response.data === undefined || response.data.length == 0) {
                            
                            // toast.info(`Sorry we don't have ${inputValue} in our food library kindly contact Admin for further assistance`, {
                            //     position: toast.POSITION.TOP_CENTER,
                            //     autoClose: false,
                            // });
                            this.setState({ showToast: true });
                        }
                        callback(response.data);
                    }
                })

                .catch((error) => this.setState({ error, fetching: false }));
        }
    };

    render() {
        const { name, value, disabled, isMulti, title, isRequired, isClearable, onChange, day, mealTypeCode, defaultOptions, addFoodItemToArry, mealModulus } = this.props;

        const { fetching, response, error, showToast, foodItem } = this.state;

        return (
            <div>
                {false ? (
                    <UncontrolledAlert color="info">
                        <Spinner message="Fetching food items" />
                    </UncontrolledAlert>
                ) : (
                    <div>
                        <div>
                            {showToast ? (
                                <div className="asyncToast" style={{maxWidth:"292px",textAlign:"center"}}>
                                    <section>
                                        <span style={{ cursor: "pointer", color: "white", display: "flex", justifyContent: "flex-end" }}> {<MdClose className="remove-icon" onClick={() => this.cancelToast()} />}</span>
                                        <span>Sorry we don't have {foodItem} in our food library kindly contact Admin for further assistance.</span>
                                    </section>
                                </div>
                            ) : null}
                        </div>
                        <div>
                            <AsyncSelect
                                isMulti={isMulti}
                                name={name}
                                defaultOptions={defaultOptions}
                                isClearable={isClearable}
                                title={title}
                                options={response ? response : []}
                                loadOptions={this.asyncGetFoodItems}
                                value={value}
                                valueKey="id"
                                disabled={disabled}
                                labelKey="name"
                                innerRef={(c) => {
                                    this.metrics = c;
                                }}
                                required={isRequired}
                                onChange={onChange}
                                day={day}
                                mealTypeCode={mealTypeCode}
                                addFoodItemToArry={addFoodItemToArry}
                                mealModulus={mealModulus}
                            />

                            {/* {!response && error && (
                            <UncontrolledAlert color="danger">
                                {error.message}
                                <div className="text-reight">
                                    <Button color="danger" onClick={this.getFoodItems}>
                                        Retry
                                    </Button>
                                </div>
                            </UncontrolledAlert>
                        )} */}
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default withFormsy(AsyncFoodLibraryDropDown);
